module.exports = __webpack_public_path__ + "img/Perks-50.1266dbf2.png";